module.exports = __webpack_public_path__ + "static/img/reject.053dce42.svg";